module.exports = __webpack_public_path__ + "static/media/fam02.58d9260c.jpg";